import React from "react";
import FeedbackCarousel from "./carouselFeedback/carousel.js";
import WrappedFormFeedback from "./formFeedback/formFeedback.js";

import styles from "./feedback.module.css";

class FeedbackSlide extends React.Component {
  render() {
    return (
      <div className={styles.container}>
        <div className={styles.feedbackCarouselWrapper}>
          <FeedbackCarousel />
        </div>
        <div style={{ flex: 0.5 }} />
        <div className={styles.wrappedFormFeedback}>
          <WrappedFormFeedback />
        </div>
      </div>
    );
  }
}

export default FeedbackSlide;
